import { ToastrService } from 'ngx-toastr';

export function isCsvFile(fileName: string): boolean {
  const extension = fileName.split('.').pop();
  return extension === 'csv';
}

export function isImageFile(fileName: string): boolean {
  const extension = fileName.split('.').pop();
  return extension === 'png' || extension === 'jpeg' || extension === 'jpg';
}

export const maxAssessmentFileSize = 1000000; // bytes// bytes

export function isValidSize(file: File, maxSize: number): boolean {
  return file.size <= maxSize;
}

export function isValidImportableFile(
  file: FileList,
  maxSize: number,
  toast: ToastrService
): boolean {
  if (!isCsvFile(file.item(0).name)) {
    toast.error('Veuillez sélectionner un fichier au format csv');
    return false;
  }
  if (!isValidSize(file.item(0), maxSize)) {
    toast.error(
      `La taille du fichier ne doit pas dépasser ${maxSize / 1000000} MB`
    );
    return false;
  }
}

export function downloadFile(blob: Blob, fileName: string): void {
  const a = document.createElement('a');
  const url = window.URL.createObjectURL(blob);
  a.href = url;
  a.download = fileName;
  a.click();
  setTimeout(() => window.URL.revokeObjectURL(url), 100);
}
